(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initCanvas(root) {
    var canvas = root.querySelector('[data-sig-canvas]');
    if (!canvas || reduced()) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var stars = [];
    var links = [];
    var w = 0;
    var h = 0;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var raf = 0;
    var mx = 0.5;
    var my = 0.35;

    function resize() {
      w = root.clientWidth || window.innerWidth;
      h = Math.max(root.scrollHeight, root.clientHeight, window.innerHeight);
      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      var n = Math.min(120, Math.floor((w * Math.min(h, 2400)) / 14000));
      stars = [];
      for (var i = 0; i < n; i++) {
        stars.push({
          x: Math.random() * w,
          y: Math.random() * h,
          z: Math.random() * 0.8 + 0.2,
          r: Math.random() * 1.8 + 0.3,
          vx: (Math.random() - 0.5) * 0.18,
          vy: (Math.random() - 0.5) * 0.18,
          hue: Math.random() > 0.55 ? 'gold' : 'neon'
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, w, h);
      var pullX = (mx - 0.5) * 30;
      var pullY = (my - 0.5) * 20;

      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        s.x += s.vx * s.z;
        s.y += s.vy * s.z;
        if (s.x < -20) s.x = w + 20;
        if (s.x > w + 20) s.x = -20;
        if (s.y < -20) s.y = h + 20;
        if (s.y > h + 20) s.y = -20;

        var x = s.x + pullX * s.z;
        var y = s.y + pullY * s.z;
        ctx.beginPath();
        ctx.arc(x, y, s.r * s.z, 0, Math.PI * 2);
        ctx.fillStyle = s.hue === 'gold'
          ? 'rgba(224,195,90,' + (0.25 + s.z * 0.45) + ')'
          : 'rgba(61,255,154,' + (0.18 + s.z * 0.4) + ')';
        ctx.fill();
      }

      for (var a = 0; a < stars.length; a++) {
        for (var b = a + 1; b < stars.length; b++) {
          var dx = stars[a].x - stars[b].x;
          var dy = stars[a].y - stars[b].y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 95) {
            ctx.strokeStyle = 'rgba(94,240,208,' + (0.1 * (1 - dist / 95)) + ')';
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(stars[a].x + pullX * stars[a].z, stars[a].y + pullY * stars[a].z);
            ctx.lineTo(stars[b].x + pullX * stars[b].z, stars[b].y + pullY * stars[b].z);
            ctx.stroke();
          }
        }
      }

      raf = requestAnimationFrame(draw);
    }

    resize();
    draw();

    root.addEventListener('pointermove', function (e) {
      var rect = root.getBoundingClientRect();
      mx = (e.clientX - rect.left) / Math.max(rect.width, 1);
      my = (e.clientY - rect.top) / Math.max(rect.height, 1);
    });

    var t = 0;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(resize, 160);
    });

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        clearTimeout(t);
        t = setTimeout(resize, 160);
      });
      ro.observe(root);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) cancelAnimationFrame(raf);
      else raf = requestAnimationFrame(draw);
    });
  }

  function initCursor(root) {
    var cursor = root.querySelector('[data-sig-cursor]');
    if (!cursor || reduced() || window.matchMedia('(pointer: coarse)').matches) return;

    var x = window.innerWidth / 2;
    var y = window.innerHeight / 2;
    var cx = x;
    var cy = y;

    window.addEventListener('pointermove', function (e) {
      root.classList.add('is-hot');
      x = e.clientX;
      y = e.clientY;
    });

    function loop() {
      cx += (x - cx) * 0.12;
      cy += (y - cy) * 0.12;
      cursor.style.transform = 'translate(' + cx + 'px,' + cy + 'px)';
      requestAnimationFrame(loop);
    }
    loop();
  }

  function initParallax(root) {
    if (reduced()) return;
    var layers = root.querySelectorAll('[data-sig-parallax]');
    if (!layers.length) return;

    var mx = 0;
    var my = 0;
    window.addEventListener('pointermove', function (e) {
      mx = (e.clientX / window.innerWidth - 0.5) * 2;
      my = (e.clientY / window.innerHeight - 0.5) * 2;
    }, { passive: true });

    function frame() {
      var sy = window.pageYOffset || 0;
      layers.forEach(function (el) {
        var depth = parseFloat(el.getAttribute('data-depth') || '0.1');
        var tx = mx * depth * 28;
        var ty = my * depth * 18 + sy * depth * 0.15;
        el.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0)';
      });
      requestAnimationFrame(frame);
    }
    frame();
  }

  function initReveals(root) {
    var nodes = root.querySelectorAll('[data-sig-in]');
    if (!nodes.length) return;
    if (reduced() || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function initRail(root) {
    var dots = root.querySelectorAll('[data-sig-jump]');
    var chapters = root.querySelectorAll('[data-sig-chapter]');
    if (!dots.length || !chapters.length) return;

    function setActive(id) {
      dots.forEach(function (d) {
        d.classList.toggle('is-active', d.getAttribute('data-sig-jump') === id);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var id = dot.getAttribute('data-sig-jump');
        var target = root.querySelector('[data-sig-chapter="' + id + '"]');
        if (!target) return;
        var top = target.getBoundingClientRect().top + window.pageYOffset - 20;
        window.scrollTo({ top: top, behavior: reduced() ? 'auto' : 'smooth' });
        setActive(id);
      });
    });

    if ('IntersectionObserver' in window) {
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(entry.target.getAttribute('data-sig-chapter'));
        });
      }, { rootMargin: '-35% 0px -45% 0px', threshold: 0.01 });
      chapters.forEach(function (c) { spy.observe(c); });
    }
  }

  function initTimeline(root) {
    var steps = root.querySelectorAll('[data-sig-step]');
    var fill = root.querySelector('[data-sig-beam-fill]');
    var timeline = root.querySelector('[data-sig-timeline]');
    if (!steps.length) return;

    function update() {
      var lit = 0;
      steps.forEach(function (step) {
        var rect = step.getBoundingClientRect();
        var mid = window.innerHeight * 0.72;
        if (rect.top < mid) {
          step.classList.add('is-lit');
          lit += 1;
        }
      });
      if (fill && timeline) {
        var pct = Math.max(0, Math.min(100, (lit / steps.length) * 100));
        fill.style.height = pct + '%';
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initMorph(root) {
    var wrap = root.querySelector('[data-sig-morph]');
    if (!wrap) return;
    var tabs = wrap.querySelectorAll('[data-morph]');
    var panels = wrap.querySelectorAll('[data-morph-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-morph');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-morph-panel') === key);
        });
      });
    });
  }

  function initCount(root) {
    var els = root.querySelectorAll('[data-sig-count]');
    if (!els.length) return;

    function run(el) {
      var to = parseInt(el.getAttribute('data-to') || '0', 10);
      if (reduced()) {
        el.textContent = String(to);
        return;
      }
      var t0 = null;
      function frame(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / 1200);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = String(Math.round(to * e));
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(run);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          run(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.45 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initDock(root) {
    var dock = root.querySelector('[data-sig-dock]');
    var portal = root.querySelector('[data-sig-chapter="portal"]');
    if (!dock || !portal) return;
    dock.hidden = false;
    if (!('IntersectionObserver' in window)) {
      dock.classList.add('is-show');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        dock.classList.toggle('is-show', !entry.isIntersecting);
      });
    }, { threshold: 0.12 });
    io.observe(portal);
  }

  function scrollToBuy() {
    var buy = document.querySelector('[data-product-root]');
    if (!buy) {
      window.scrollTo({ top: 0, behavior: reduced() ? 'auto' : 'smooth' });
      return;
    }
    var top = buy.getBoundingClientRect().top + window.pageYOffset - 12;
    window.scrollTo({ top: top, behavior: reduced() ? 'auto' : 'smooth' });
  }

  async function book(variantId) {
    if (!variantId) {
      scrollToBuy();
      return;
    }
    try {
      var res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('fail');
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      if (window.themeSettings && window.themeSettings.cartDrawer === false) {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    } catch (e) {
      scrollToBuy();
    }
  }

  function initBook(root) {
    var id = root.getAttribute('data-variant-id');
    root.querySelectorAll('[data-sig-book]').forEach(function (btn) {
      btn.addEventListener('click', function () { book(id); });
    });
  }

  function initFaq(root) {
    var items = root.querySelectorAll('.sig-term__body details');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  ready(function () {
    var root = document.querySelector('[data-sig]');
    if (!root) return;
    document.body.classList.add('pdp-webinar-mode');
    initCanvas(root);
    initCursor(root);
    initParallax(root);
    initReveals(root);
    initRail(root);
    initTimeline(root);
    initMorph(root);
    initCount(root);
    initDock(root);
    initBook(root);
    initFaq(root);
  });
})();
